// External Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Internal Modules
import { DatePickerModule } from 'src/app/modules/date-picker/date-picker.module';

// Components
import { DemandReductionComponent } from './demand-reduction.component';
import { DemandAdjustmentButtonComponent } from './components/demand-adjustment-button/demand-adjustment-button.component';
import { DemandConstraintsButtonComponent } from './components/demand-constraints-button/demand-constraints-button.component';
import { DemandNotesButtonComponent } from './components/demand-notes-button/demand-notes-button.component';
import { DemandReductionContainerComponent } from './components/demand-reduction-container/demand-reduction-container.component';
import { DemandReductionTableComponent } from './components/demand-reduction-table/demand-reduction-table.component';
import { HydroConditionButtonComponent } from './components/hydro-condition-button/hydro-condition-button.component';


@NgModule({
  declarations: [
    DemandReductionComponent,
    DemandAdjustmentButtonComponent,
    DemandConstraintsButtonComponent,
    DemandNotesButtonComponent,
    DemandReductionContainerComponent,
    DemandReductionTableComponent,
    HydroConditionButtonComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([{ path: 'demand-reduction', component: DemandReductionComponent }]),
    NgbModule,
    FormsModule,
    DatePickerModule
  ]
})
export class DemandReductionModule { }
